import React from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import _ from 'lodash';
import Moment from 'moment';

import { employeeVacationChangeSort } from '../../redux/employeeVacationReducer';
import ReactMoment from "react-moment";

import BeatLoader from "react-spinners/BeatLoader";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

const useStyles = makeStyles({
    tblList: {
        backgroundColor: "white",
        borderCollapse: "collapse",
        width: "100%",

        "& thead": {
            backgroundColor: "#c5e2ff",
            color: "#45525c",
        },

        "& tr": {
            cursor: "pointer",
        },

        "& tr.alt": {
            backgroundColor: "#f7fbff",
        },

        "& tr.lastWorkingEntity": {
            border: "2px solid #da59da",
        },

        "& tbody tr:hover, tbody tr.alt:hover": {
            backgroundColor: "#ffffcc !important",
        },

        "& th": {
            border: "1px solid #B0B0B0",
            textAlign: "center",
        },

        "& td": {
            border: "1px solid #B0B0B0",
            textAlign: "center",
        },
    },
});

export default function EmployeeVacationList() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();

    const { isLoading, filter, entities, errors } = useSelector(state => {
        return state.employeeVacation;
    });

    const sorts = JSON.parse(filter.sort);

    const _getSortDirection = (field) => {
        const i = _.findIndex(sorts, function (o) { return o.property == field; });
        return (i >= 0) ? sorts[i].direction : "";
    };

    const changeSort = (field) => {
        dispatch(employeeVacationChangeSort(field, filter));
    };

    const showMonthDetail = (calMonth) => {
        //console.log('showMonthDetail', calMonth);
        history.push(`/employeeVacationDetails/${calMonth}`);
    }

    const showDetail = (id) => {
        history.push(`/employeeVacationDetail/${id}`);
    }

    let i = filter.qtyPerPage * (filter.page - 1) + 1;

    return (
        <table className={classes.tblList} >
            <thead>
                <tr>
                    <th><span>行</span></th>
                    <th onClick={(_) => changeSort('branch')}><span>分行</span><MyArrowIcon direction={_getSortDirection("branch")} /></th>
                    <th onClick={(_) => changeSort('id_employee')}><span>編號</span><MyArrowIcon direction={_getSortDirection("id_employee")} /></th>
                    <th onClick={(_) => changeSort('name')}><span>同事</span><MyArrowIcon direction={_getSortDirection("name")} /></th>
                    <th onClick={(_) => changeSort('cal_month')}><span>月份</span><MyArrowIcon direction={_getSortDirection("cal_month")} /></th>
                    <th onClick={(_) => changeSort('qty_vacation')}><span>放假日數</span><MyArrowIcon direction={_getSortDirection("qty_vacation")} /></th>
                    {/*<th>&nbsp;</th>*/}
                </tr>
            </thead>

            {isLoading
                ?
                <tbody>
                    <tr>
                        <td colSpan={10} style={{ padding: "3em", textAlign: "center", }}><BeatLoader color={"#c0c0c0"} /></td>
                    </tr>
                </tbody>
                :
                (errors !== "")
                    ?
                    <tbody>
                        <tr>
                            <td colSpan={10} style={{ padding: "3em", textAlign: "center", }}><em>{errors}</em></td>
                        </tr>
                    </tbody >
                    :
                    <tbody>
                        {
                            entities.length < 1
                                ? <tr>
                                    <td colSpan={10} style={{ padding: "3em", textAlign: "center", }}><em>沒有符合的記錄</em></td>
                                </tr>
                                : entities.map((entity, index) => {
                                    const calMonth = new Moment(entity.CalMonth).format('YYYY-MM-DD');

                                    return <tr key={entity.Id} className={clsx({ "alt": index % 2 == 1, "normal": index % 2 == 0 })} onClick={() => { showMonthDetail(calMonth) }}>
                                        <td>{i++}</td>
                                        <td>{entity.Branch}</td>
                                        <td>{entity.IdEmployee}</td>
                                        <td>{entity.Name}</td>
                                        <td>{entity.CalMonth ? <ReactMoment format="YYYY-MM-DD" date={entity.CalMonth} /> : "---"}</td>
                                        <td>{entity.QtyVacation ? entity.QtyVacation : "-"}</td>
                                        {/*<td><Button onClick={(e) => { e.stopPropagation(); showDetail(entity.Id); }} variant="contained" size="small" >修改</Button></td>*/}
                                    </tr>
                                })
                        }
                    </tbody>
            }
        </table>
    );
}

function MyArrowIcon({ direction }) {
    switch (direction) {
        case "ASC": return <ArrowDropUpIcon />;
        case "DESC": return <ArrowDropDownIcon />;
        default: return null;
    }
}
